import './answer-checkbox.styl';

function AnswerCheckbox({ 
  text, 
  checked, 
  onChange, 
  label,
  className = '',
  ...props 
}) {
  const handleClick = () => {
    onChange(!checked);
  };

  return (
    <div 
      className={`answer-checkbox ${checked ? 'answer-checkbox--checked' : ''} ${className}`}
      onClick={handleClick}
      tabIndex={0}
      role="checkbox"
      aria-checked={checked}
      {...props}
    >
      {label && (
        <span className="answer-checkbox__label">
          {label}
        </span>
      )}
      <div className="answer-checkbox__content">
        <span className="answer-checkbox__text">
          {text}
        </span>
      </div>
    </div>
  );
}

export default AnswerCheckbox;